import * as React from 'react';

// REDUX
import { useAppSelector } from '../store';

// PACKAGES
import { Link } from 'react-router-dom';

// COMPONENTS
import Button from './Button';
import DisplayDate from './DisplayDate';
import StatusIcon from './StatusIcon';

// ICONS
import { ReactComponent as PlusIcon } from '../assets/svg/plus.svg';

// TYPES
import { StaffFetchTraining } from '../api/models/staff-fetch-training';

interface ProfileTrainingTypes {
	training?: Array<StaffFetchTraining>;
	defaultMaxItems?: number;
	isYou?: boolean;
	isPastProfile?: boolean;
}

const ProfileTraining: React.FC<ProfileTrainingTypes> = ({ training, defaultMaxItems, isYou, isPastProfile }) => {
	// Check if Organisation is active
	const isOrganisationActive = useAppSelector((state) => state.user.isOrganisationActive);

	const [maxTrainingItem, setMaxTrainingItem] = React.useState<number>(defaultMaxItems || 5);

	return (
		<>
			{training && training.length > 0 && (
				<section className="info-section">
					<div className="section-header">
						<h2 className="header-name color-dark">Training</h2>
					</div>

					{training.slice(0, maxTrainingItem).map((item, index) => {
						return (
							<div key={index} className="row-container">
								<div className="row detail-row">
									<div className="col-auto pdl-0 pdr-0">
										<StatusIcon statusType={item.status || 'Error'} />
									</div>

									<div className="col-md-auto full-width">
										<div className="row detail-info">
											<div className="col-lg-3 detail-name">
												{item.title}
												<p className="text-subtitle">{item.summary}</p>
											</div>

											<div className={`col-lg-2 detail-label ${item.status?.toLowerCase()}`}>
												{item.completionStatus ? item.completionStatus : null}
											</div>

											{item.status === 'Success' && (
												<div className="col-lg-4 detail-status">
													<div className="title">Date</div>
													<time className="name">
														<DisplayDate>{item.completed}</DisplayDate>
													</time>
												</div>
											)}
										</div>
									</div>

									<div className="col-auto pdr-0 link-group">
										{!isPastProfile && (
											<>
												{isOrganisationActive && (
													<>
														{item.status === 'Success' || !isYou ? (
															<Link className="btn-text pdr-0" to={`/training/${item.id}`}>
																View
															</Link>
														) : (
															<Link className="btn-text pdr-0" to={`/training/${item.id}`}>
																Start
															</Link>
														)}
													</>
												)}
											</>
										)}
									</div>
								</div>
							</div>
						);
					})}

					{maxTrainingItem < training.length && (
						<Button
							className="btn-secondary btn-show-more"
							onClick={() => setMaxTrainingItem(training.length)}
							buttonIcon={<PlusIcon className="link-icon" />}
						>
							Show {training.length - maxTrainingItem} more
						</Button>
					)}
				</section>
			)}
		</>
	);
};

export default ProfileTraining;
